import BindVideoModal from './BindVideoModal';

export default BindVideoModal;
